@if ({}; as STATE) {
  <section class="subscriber-ads-layout"></section>
}
